import { ArrowIcon } from "assets/icons";
import { If } from "components";
import { t } from "i18next";
import { TableItemActionsModal } from "ui/TableItemActionsModal";

import { TableItemStatusControlProps } from "./TableItemStatusControl.types";

import styles from "./TableItemStatusControl.module.scss";

const TableItemStatusControl = ({
  activeStatusIndex,
  openedItemStatusesIndex,
  statusesList,
  rowIndex,
  hideDisabled = false,
  disabled,
  setOpenedItemStatusesIndex
}: TableItemStatusControlProps) => {
  const isListOpen = openedItemStatusesIndex === rowIndex;

  const toggleIsListOpen = () => {
    if (isListOpen) {
      setOpenedItemStatusesIndex(null);
    } else {
      setOpenedItemStatusesIndex(rowIndex);
    }
  };

  return (
    <div className={styles.statusControlContainer}>
      <button
        className={styles.activeStatusBtn}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          toggleIsListOpen();
        }}
        disabled={disabled}
        style={{
          backgroundColor: statusesList[activeStatusIndex]?.backgroundColor
        }}
      >
        {t(statusesList[activeStatusIndex]?.label)}
        {!disabled && <ArrowIcon width={18} height={18} />}
      </button>

      <If condition={isListOpen}>
        <TableItemActionsModal
          actionsList={statusesList.map((status, index) => ({
            ...status,
            disabled: activeStatusIndex === index
          }))}
          handleClose={toggleIsListOpen}
          className={styles.statusesListModal}
          hideDisabled={hideDisabled}
        />
      </If>
    </div>
  );
};

export default TableItemStatusControl;
